module.exports = __webpack_public_path__ + "img/imagenMM.aefbd13a.gif";